angular.module('rjmNg.directives').directive "cloudbiIntegration", [
  "$url"
  ($url) ->
    restrict: "E"
    template: "<div ng-include='view.getTemplateUrl()'></div>"
    replace: true
    require: "^?rjmUi"
    scope:
      connectionType: "="
    controllerAs: "view"
    bindToController: true
    controller: [
      "$routeParams"
      "$window"
      "$location"
      "Integrations"
      "InputConnections"
      "CONNECTIONS"
      "connectionUtils"
      "clientEventService"
      "notification"
      "$clientAppUrl"
      "$q"
      "clientEventTypes"
      "appRoute"
      "$url"
      (
        $routeParams
        $window
        $location
        Integrations
        InputConnections
        CONNECTIONS
        connectionUtils
        clientEventService
        notification
        $clientAppUrl
        $q
        clientEventTypes
        appRoute
        $url
      ) ->

        view = @

        view.getTemplateUrl = () ->
          templateUrl = connectionUtils.getUIConfig(view.connectionType)?.templateUrl
          if templateUrl?
            return templateUrl
          throw new Error "Could not resolve a template URL. Please verify that the integration type is correct."

        view.loader = $url("/images/loadingIndicator-small.gif")
        view.connectionsUrl = appRoute("/settings/connection")

        view.clientId = $routeParams.clientId
        view.connectionId = if $routeParams.connectionId then $routeParams.connectionId else null

        view.editingExisting = view.connectionId?
        view.isConnected = false
        view.loading = true
        view.saving = false
        view.chooseProfile = $location.search().profiles # User needs to select profile
        view.selectedProfile = false
        view.connectedData = false
        view.client = {}
        view.baseUrl = $url('')
        view.nextStepUrl = null
        view.saveOptions = {}

        view.profileId = null

        view.SUBDOMAIN_REGEX = connectionUtils.REGEX.subdomain
        view.HOST_REGEX = connectionUtils.REGEX.host

        IntegrationsInstance = Integrations(view.clientId)
        InputConnectionsInstance = InputConnections(view.clientId)

        handleError = (message) ->
          notification.clear("global")
          notification.error "Something went wrong.", message, "global"

        handleSuccess = (message) ->
          notification.clear("global")
          notification.success "Success.", message, "global"

        handleWarning = (message) ->
          notification.clear("global")
          notification.warning "Warning.", message, "global", null, 10

        handleAuthError = (response) ->
          view.saving = false

          if response?.data?.error?
            handleError response.data.error
          else
            handleError "An error occurred while authorizing this integration. Please try again."

        view.back = ->
          $location.path(view.connectionsUrl)

        view.authorize = () ->
          switch view.integrationConfig.auth.type
            when "http"
              IntegrationsInstance.httpAuthorize(view.connection).then (response) ->
                view.saving = false
                handleSuccess "Your integration was successfully authorized"
              , (response) -> handleAuthError response
            when "oauth1"
              IntegrationsInstance.oauth1Authorize(view.connection).then (response) ->
                $window.location.href = response.authorize_url
              , (response) -> handleAuthError response
            when "oauth2"
              IntegrationsInstance.oauth2Authorize(view.connection).then (response) ->
                $window.location.href = response.authorize_url
              , (response) -> handleAuthError response
            when "custom"
              IntegrationsInstance.customAuthorize(view.connection).then (response) ->
                view.saving = false
                handleSuccess "Your integration was successfully authorized"
              , (response) -> handleAuthError response
            else
              view.saving = false
              handleError "Authorization not defined for " + view.integrationConfig.type + ". Please contact support."

        view.selectProfile = (save = false) ->
          if view.connectionType is CONNECTIONS.TYPES.AD_WORDS
            if view.saveOptions.customerIds? and view.saveOptions.customerIds isnt ""
              view.connection.properties.customer_ids = view.saveOptions.customerIds
            else
              handleWarning "Please select at least one Google Ads profile for the integration."
              return

          view.connection.properties.view_id = view.profileId
          if save
            view.saving = true
            InputConnectionsInstance.save(view.connection)
            .then ->
              view.selectedProfile = true
              view.chooseProfile = false
              handleSuccess "Your integration was successfully saved."
            .catch ->
              handleError "An error occurred while saving this integration. Please try again."
            .finally () ->
              view.saving = false

            InputConnectionsInstance.deleteTemporarySecrets(view.connection.id)
          else
            view.selectedProfile = true

        view.setConnectionProperty = (prop, value) ->
          view.connection.properties[prop] = value

        view.save = (authorize = false) ->
          view.saving = true

          # never save credentials when not authorizing an integration
          delete view.connection.credentials if not authorize

          angular.extend view.connection.properties,
            product: "dashboard"

          # add default config properties
          if view.integrationConfig.defaultProperties
            angular.extend view.connection.properties, view.integrationConfig.defaultProperties

          # add default properties to new connections before saving
          if view.connection.id is null
            dsdParts = view.integrationConfig.default_start_date.split " "
            dsdAmount = parseInt(dsdParts[0])
            dsdUnit = dsdParts[1]
            relativeStartDate = moment().add(dsdAmount, dsdUnit).format('YYYY-MM-DD 00:00:00')

            angular.extend view.connection.properties,
              created: moment().format('YYYY-MM-DD HH:mm:ss')
              status: CONNECTIONS.STATUS.ACTIVE
              start_date: relativeStartDate

            if view.integrationConfig.current_version
              view.connection.properties.version = view.integrationConfig.current_version

          InputConnectionsInstance.save(view.connection, not authorize).then () ->
            if authorize
                view.authorize()
            else
              view.saving = false
              handleSuccess "Your integration was successfully saved!"
          , () ->
            handleError "An error occurred while saving this integration. Please try again."
            view.saving = false

        getConnectedData = () ->
          clientEventService.fetch().then (result) ->
            result.data.some (event) ->
              event.type is clientEventTypes.FIRST_DATA_ADDED

        handleCallbackResult = () ->
          error = $location.search().error
          saved = $location.search().saved

          if error
            view.saving = false
            errorMessage = if typeof error is "string" then error else
              "An error occurred while saving this integration."

            handleError errorMessage + ". Please try again."
            return

          if saved
            view.saving = false
            view.isConnected = true
            notification.success("#{view.integrationConfig.display_name} Integration Saved",
              "Connected to #{view.integrationConfig.display_name} successfully!", "global")
            return

        getConnection = (connectionId, newConnectionType) ->
          if connectionId?
            InputConnectionsInstance.getByMetaId(view.connectionId, false)
          else
            $q.when
              id: null
              name: newConnectionType
              type: newConnectionType
              properties: {}
              credentials: {}

        init = () ->
          connectionUtils.getIntegrationConfig(view.clientId, view.connectionType, true)
          .then (config) ->
            view.integrationConfig = config

            $q.all([
              getConnectedData()
              getConnection(view.connectionId, config.type)
            ])
          .then ([connectedData, connection]) ->
            view.connectedData = connectedData
            view.connection = connection
            view.profileId = view.connection.properties.view_id
          .then () ->
            handleCallbackResult()
          .catch (error) ->
            handleError "We failed to load the configuration for this integration. Please try again."
          .finally () ->
            view.loading = false

        @$onInit = ->
          init()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      if rjmUi?
        scope.$watchGroup [
          "view.loading"
          "view.saving"
        ], () ->
          if scope.view.loading
            loadingUiMessage = "Loading integration page"
          else if scope.view.saving
            loadingUiMessage = "Saving integration"
          else
            loadingUiMessage = ""
          rjmUi.loadingUi("integration-editor", scope.view.loading or scope.view.saving, loadingUiMessage)

]
